const sanctumConfig = {
    //apiUrl: "http://localhost:8000",
    apiUrl: "https://multiploevtest.arimaslab.com", 
    //apiUrl: "https://tesseramento.europaverde.it",
    
    csrfCookieRoute: "api/sanctum/csrf-cookie",
    signInRoute: "login",
    signOutRoute: "logout",
    userObjectRoute: "api/me",
    twoFactorChallengeRoute: "two-factor-challenge"
};

export default sanctumConfig;
